import React, { Suspense, useEffect, useState } from "react";
import Loading from "../components/Loading";
import history from "../common/utils/router";
import Menu from '../components/Menu'
import { BrowserRouter, Route, Routes, useNavigate, useLocation } from "react-router-dom";
import { useStoreState, useStoreActions } from "easy-peasy";
import { authRoutes, generalRoutes } from "./routes";
import baseApiObject from "../api/baseApi";
import loginApiObject from "../api/loginApi";
import tokenManager from "../utils/tokenManager";
import { redirectToSsoLogin } from "../utils/sso";

const Redirect = ({ isAuthenticated }) => {
  const navigate = useNavigate();
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    if (isAuthenticated === null) return; // Aguarda carregar
    setAuthReady(true); // Marca como carregado
  }, [isAuthenticated]);

  useEffect(() => {
    if (!authReady) return;
    if (isAuthenticated) {
      navigate("/maker");
    } else {
      redirectToSsoLogin("/maker");
    }
  }, [authReady, isAuthenticated, navigate]);

  return <Loading />;
};

/** Protege as rotas gerais (tudo que não é tenant/register): sem token no cookie
 *  compartilhado, manda pro login do SSO em vez de renderizar a tela (que ia
 *  quebrar nas chamadas de API por falta de token). */
const RequireAuth = ({ children }) => {
  const location = useLocation();
  const [hasToken] = useState(() => Boolean(tokenManager.getToken()));

  useEffect(() => {
    if (!hasToken) {
      redirectToSsoLogin(location.pathname);
    }
  }, [hasToken, location.pathname]);

  if (!hasToken) return <Loading />;
  return children;
};

const AppRoutes = () => {

  const initializeAuth = useStoreActions((actions) => actions.auth.initializeAuth);
  const isAuthenticated = useStoreState((state) => state.auth.isAuthenticated);
  const token = useStoreState((state) => state.auth.token);

  useEffect(() => {
    initializeAuth();
    // Não é mais necessário chamar setAppAccessToken
    // O interceptor Axios agora lê o token automaticamente do tokenManager
  }, [initializeAuth]);

  // Observer: atualiza API objects sempre que o token mudar
  useEffect(() => {
    if (token) {
      baseApiObject.setAppAccessToken(token);
      loginApiObject.setAppAccessToken(token);
      // API objects updated with new token
    }
  }, [token]);

  return (
    <BrowserRouter
      history={history}
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}>
      <Suspense fallback={<Loading />}>
        {isAuthenticated !== null && (
          <Routes>
            <Route path="/" element={<Redirect isAuthenticated={isAuthenticated} />} />

            {generalRoutes.map(({ path, component, ...props }, index) => (
              <Route path={path} key={index} {...props} element={
                <RequireAuth>
                  <Menu hideMenu={props.hideMenu} forceMenuState={props.forceMenuState}>
                    {component}
                  </Menu>
                </RequireAuth>
              } />
            ))}

            {authRoutes.map(({ path, component, ...props }, index) => (
              <Route path={path} key={index} {...props} element={component} />
            ))}

          </Routes>
        )}
      </Suspense>
    </BrowserRouter>
  );
};

export default AppRoutes;
